import { styled } from '@linaria/react';

// TODO: refactor
export const RowWrapper = styled.div<{
  expand: boolean;
  showBottomBorder: boolean;
}>`
  --acca-row-wrapper-height: 82px;
  --acca-row-wrapper-padding: ${({ expand }) => (expand ? '9px 0' : '10px 1px')};

  @media (min-width: 768px) {
    --acca-row-wrapper-padding: 10px 0;
  }

  width: 100%;
  min-height: 60px;

  height: ${({ expand }) => (expand ? 'unset' : 'var(--acca-row-wrapper-height)')};

  max-height: ${({ expand }) => (expand ? '1000px' : '82px')};

  border-bottom: 1px solid var(--oc-line-secondary);
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  transition: max-height 0.3s;
  padding: 5px 10px;

  overflow: hidden;
  margin-top: -1px;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
    border-radius: 0;
    padding: 5px 20px;
  }
`;

export const Divider = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
  }

  border-bottom: 5px solid var(--oc-line-secondary);
  width: calc(100% + 40px);
  margin: 0 -20px;
`;

export const AccaMatchStatsWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
`;
